import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.remote-app-access.add', {
        url: '/add',
        views: {
            '@company.manage-application': 'companyManageApplicationRemoteAppAdd',
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/add/add-remote-app.state.js